import { Box, Icon, IconButton, Typography, useTheme } from "@mui/material";
import { useState } from "react";
import { PhotoDto } from "../../../api/psc";
import { DialogHeader } from "../../../components/exports";
import {
    DefaultDarkProjectImagePath,
    DefaultProjectImagePath,
} from "../../../constants/ProjectConstants";
import { toJalaliDate } from "../../../utils/date";

export default function ProjectPhotoGallery(props: {
    photos: PhotoDto[];
    selectedIndex: number;
}) {
    const theme = useTheme();
    const [index, setIndex] = useState<number>(props.selectedIndex || 0);

    const projectPlaceHolder =
        theme.palette.mode === "light"
            ? DefaultProjectImagePath
            : DefaultDarkProjectImagePath;

    const photos = props.photos;
    const hasPhoto = photos.length > 0;

    const goToNext = () => {
        setIndex(index + 1);
    };

    const goToPrev = () => {
        setIndex(index - 1);
    };

    return (
        <Box>
            <DialogHeader title="گالری تصاویر پروژه" />

            <Box sx={{ p: 2, width: 732 }}>
                <Box
                    sx={{
                        width: 700,
                        height: 525,
                        borderRadius: "4px",
                        overflow: "hidden",
                        position: "relative",
                    }}
                >
                    <img
                        style={{ width: "100%", height: "100%" }}
                        src={
                            hasPhoto
                                ? photos[index].imageUrl
                                : projectPlaceHolder
                        }
                    />

                    {/* shooting date */}
                    <Box
                        sx={{
                            position: "absolute",
                            right: 16,
                            bottom: 16,
                            background: "rgba(0,0,0,0.2)",
                            p: 1,
                            backdropFilter: "blur(20px)",
                            borderRadius: "4px",
                        }}
                    >
                        <Typography color={"white"}>
                            {toJalaliDate(photos[index].shootingDate)}
                        </Typography>
                    </Box>

                    {/* go prev button */}
                    <IconButton
                        disabled={index === photos.length - 1}
                        onClick={goToNext}
                        sx={{
                            position: "absolute",
                            right: 16,
                            top: "40%",
                            background: "rgba(0,0,0,0.3)",
                            backdropFilter: "blur(20px)",
                        }}
                    >
                        <Icon sx={{ fontSize: "30px", color: "white" }}>
                            chevron_left
                        </Icon>
                    </IconButton>

                    {/* go next button */}
                    <IconButton
                        disabled={index === 0}
                        onClick={goToPrev}
                        sx={{
                            position: "absolute",
                            left: 16,
                            top: "40%",
                            background: "rgba(0,0,0,0.3)",
                            backdropFilter: "blur(20px)",
                        }}
                    >
                        <Icon sx={{ fontSize: "30px", color: "white" }}>
                            chevron_right
                        </Icon>
                    </IconButton>
                </Box>

                <Box
                    sx={{
                        overflowX: "scroll",
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        gap: 1,
                        mt: 2,
                    }}
                >
                    {photos.map((p, i) => {
                        return (
                            <Box
                                onClick={() => setIndex(i)}
                                key={p.imageId}
                                component="img"
                                sx={{
                                    height: 50,
                                    cursor: "pointer",
                                    display: "block",
                                    borderRadius: "4px",
                                    opacity: i === index ? 1 : 0.75,
                                }}
                                src={p.imageUrl}
                            />
                        );
                    })}
                </Box>
            </Box>
        </Box>
    );
}
